export const FIREBASE_MEASUREMENT_ID_PATTERN = /^G-[A-Z0-9]+$/;
export const GTAG_SCRIPT_ORIGIN = "https://www.googletagmanager.com/gtag/js";
const TRANSPORT_MARKER = "__vtkFirebaseAnalyticsTransportV1";

export function isValidFirebaseMeasurementId(value) {
  return FIREBASE_MEASUREMENT_ID_PATTERN.test(String(value || "").trim());
}

export function initializeFirebaseAnalyticsTransport(measurementId, browserWindow, browserDocument) {
  const id = String(measurementId || "").trim();
  if (!browserWindow || !browserDocument || !isValidFirebaseMeasurementId(id)) return null;

  const initialized = browserWindow[TRANSPORT_MARKER];
  if (initialized) return initialized.measurementId === id ? initialized : null;

  browserWindow.dataLayer = browserWindow.dataLayer || [];
  const gtag = browserWindow.gtag || function gtag() {
    browserWindow.dataLayer.push(arguments);
  };
  browserWindow.gtag = gtag;

  const existing = Array.from(browserDocument.scripts || []).some((script) => {
    try {
      const url = new URL(script.src);
      return url.origin + url.pathname === GTAG_SCRIPT_ORIGIN && url.searchParams.get("id") === id;
    } catch {
      return false;
    }
  });
  if (!existing) {
    const script = browserDocument.createElement("script");
    script.async = true;
    script.src = `${GTAG_SCRIPT_ORIGIN}?id=${encodeURIComponent(id)}`;
    browserDocument.head.appendChild(script);
  }

  gtag("js", new Date());
  // The explicit acceptance action owns the one-event budget. Initializing the
  // transport must not emit an automatic page_view.
  gtag("config", id, {send_page_view: false});

  const transport = Object.freeze({
    measurementId: id,
    logEvent(eventName, params = {}) {
      gtag("event", eventName, {...params, send_to: id});
    },
  });
  browserWindow[TRANSPORT_MARKER] = transport;
  return transport;
}
